import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';

import Const from '../../Const';
import Table from '../../../common/table/Table';
import ExpandTitle from '../../common/expand-title';
import SourceSpan from '../../common/source-span';
import { compose } from 'redux';
import { REDUCER_NAME, setAPIParams } from '../../reducer';
import TimeZoneHandle from '../../../common/timezone-handle';
import { listLanguage } from './../../../../configs/LanguageConfig';
import { memoize } from 'lodash';

const hideColumns = ['newsId'];

class NATable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.memoizedTransformData = memoize(this.transformData);
  }

  componentWillReceiveProps(nextProps) {
    this.handleChangeFilterCondition(nextProps);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // const { isLoading } = this.props;
    // const isFetchDone = isLoading === false && prevProps.isLoading === true;
    // const dontHasScroll =
    //   this.tableRef.current.getClientHeight() ===
    //   this.tableRef.current.getScrollHeight();
    // console.log("Get Client Height: ", this.tableRef.current.getClientHeight());
    // console.log("Get Scroll Height: ", this.tableRef.current.getScrollHeight());
    // if (isFetchDone && dontHasScroll) {
    //     this.setNextPageIfNeeded();
    // }
  }

  componentWillUnmount() {
    this.memoizedTransformData.cache.clear();
  }

  handleChangeFilterCondition = nextProps => {
    const {
      commonData,
      setAPIParams,
      currentTab,
      currentChildTab,
    } = this.props;
    const sourceCode = commonData.filterCondition[Const.SOURCE_CODE];
    const nextSourceCode =
      nextProps.commonData.filterCondition[Const.SOURCE_CODE];
    const { apiParams } = commonData;
    if (sourceCode && !nextSourceCode) {
      this.tableRef.current.scrollToTop();
      setTimeout(() => {
        setAPIParams(
          { parentTab: currentTab, childTab: currentChildTab },
          {
            ...apiParams,
            SourceCode: null,
            Page: 1,
          },
        );
      }, 0);
    }
    if (!sourceCode && nextSourceCode) {
      this.tableRef.current.scrollToTop();
      setTimeout(() => {
        setAPIParams(
          { parentTab: currentTab, childTab: currentChildTab },
          {
            ...apiParams,
            SourceCode: nextSourceCode,
            Page: 1,
          },
        );
      }, 0);
    }
  };

  transformData = (filteredIds = []) => {
    const { list, i18n, dateKey, dateTitleFormat } = this.props;
    const listStartFormat = filteredIds.map(id => {
      const format =
        i18n.locale === listLanguage.en
          ? dateTitleFormat || 'dddd, MMMM DD, YYYY'
          : dateTitleFormat || 'dddd, DD MMMM, YYYY';
      return {
        id,
        date: moment(list[id][dateKey]).format(format),
        rawDate: list[id][dateKey],
      };
    });

    const groups = listStartFormat.reduce((groups, item) => {
      const date = item.date;
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(item.id);
      return groups;
    }, {});

    return Object.keys(groups)
      .map(date => {
        return {
          renderTitle: () => {
            return date;
          },
          ids: [...new Set(groups[date])].sort((a, b) => {
            if (
              moment(list[a][dateKey]).format() >
              moment(list[b][dateKey]).format()
            ) {
              return -1;
            }

            return 1;
          }),
          canToggle: true,
          date,
          rowStyle: {
            cursor: 'pointer',
          },
        };
      })
      .concat()
      .sort((a, b) => {
        if (
          moment(a.date).format('YYYY-MM-DD') >
          moment(b.date).format('YYYY-MM-DD')
        ) {
          return -1;
        }

        return 1;
      });
  };

  getIds = () => {
    const { ids } = this.props;
    return this.memoizedTransformData(ids);
  };

  handleScroll = e => {
    const {
      currentChildTab,
      currentTab,
      setAPIParams,
      commonData,
      isShortByFavorite,
      isLoading,
    } = this.props;
    if (isShortByFavorite && isLoading) return;
    const {
      totalPage,
      apiParams: { Page },
    } = commonData;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    let newPage = null;
    if (bottom) {
      if (Page >= totalPage) return;
      newPage = Page + 1;
      this.tableRef.current.scrollTop(e.target.scrollTop - 20);
      !isLoading &&
        setAPIParams(
          { parentTab: currentTab, childTab: currentChildTab },
          { Page: newPage },
        );
    }
  };

  isToday = (momentDate, TODAY) => {
    return momentDate.isSame(TODAY, 'd');
  };

  getStoreName = type => {
    switch (type) {
      case 'an':
        return 'autoNewsData';
      case 'pa':
        return 'premiumAnalysisData';
      case 'mr':
        return 'mostRecentData';
      case 'mp':
        return 'mostPopularData';
      case 'c':
        return 'contributorsData';
      case 'r':
        return 'rumorsData';
      default:
        return 'aggregatorNewsData';
    }
  };

  onToggleRow = () => {
    if (
      this.tableRef.current.getClientHeight() ===
      this.tableRef.current.getScrollHeight()
    ) {
      this.setNextPageIfNeeded();
    }
  };

  setNextPageIfNeeded = () => {
    const {
      currentChildTab,
      currentTab,
      setAPIParams,
      commonData,
      isShortByFavorite,
      isLoading,
    } = this.props;
    if (isShortByFavorite && isLoading) return;
    const {
      totalPage,
      apiParams: { Page },
    } = commonData;
    const newPage = Page + 1;
    if (newPage >= totalPage) {
      return;
    }
    setAPIParams(
      { parentTab: currentTab, childTab: currentChildTab },
      { Page: newPage },
    );
  };

  onRowClick = id => {
    const {
      list,
      listOrganizationByOrganCode,
      syncType,
      componentId,
    } = this.props;
    const news = list[id];
    if (syncType === TYPE_DISABLE || !news.organCode) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[news.organCode],
      componentId,
    });
  };

  render() {
    const {
      listColumn = [],
      list,
      ids,
      isLoading = true,
      type,
      isGroupData = true,
      isOnlyShowDate,
    } = this.props;

    const REFERENCE = moment(); // fixed just for testing, use moment();
    var TODAY = REFERENCE.clone().startOf('day');
    const optionalProps = isGroupData
      ? {
          groups: this.getIds(),
        }
      : {
          ids,
        };

    return (
      <Table
        clickRow={this.onRowClick}
        onToggleRow={this.onToggleRow}
        {...optionalProps}
        scrollRef={this.tableRef}
        onScrollFunction={this.handleScroll}
        className="custom-table scroll-table table-striped border-table table-hover table-news w-100"
        stickyFirstColumn={false}
        getDataFromRedux={() => {
          return list;
        }}
        hideColumns={hideColumns}
        columnDraggable={false}
        rowDraggable={false}
        isLoading={isLoading}
        schema={Object.keys(listColumn).map(item => {
          const title = `newsAndAnalysis.listTitleTable.${item}`;
          const key = listColumn[item];
          const result = {
            key,
            title,
          };

          if (
            key === Const.CommonTable.TIME ||
            key === Const.AutoNewsTable.TIME
          ) {
            const extra = {};
            if (isOnlyShowDate) {
              extra.title = I18n.t('newsAndAnalysis.date');
            }
            return {
              disableSort: true,
              disableResize: true,
              ...result,
              ...extra,
              thStyle: { width: '50px', textAlign: 'center' },
              render: text => {
                const isToday = this.isToday(moment(text), TODAY);
                if ((isGroupData || isToday) && !isOnlyShowDate) {
                  return (
                    <div className="font-weight-light d-flex align-items-center">
                      <TimeZoneHandle time={text} format={'HH:mm'} />
                    </div>
                  );
                }

                return (
                  <div className="font-weight-light d-flex align-items-center">
                    <TimeZoneHandle time={text} format={'MM/DD'} />
                  </div>
                );
              },
            };
          }

          if (key === Const.CommonTable.TICKER) {
            return {
              ...result,
              isString: true,
              thStyle: { width: '50px', textAlign: 'left' },
              render: text => (
                <div className="d-flex align-items-center">{text}</div>
              ),
            };
          }

          if (key === Const.CommonTable.NEWS) {
            return {
              disableSort: true,
              ...result,
              thStyle: { textAlign: 'left' },
              render: (text, item, width) => {
                return (
                  <ExpandTitle width={width} item={item}>
                    {text}
                  </ExpandTitle>
                );
              },
            };
          }

          if (key === Const.CommonTable.RUMORS) {
            return {
              disableSort: true,
              ...result,
              thStyle: { textAlign: 'left' },
              render: (text, item) => (
                <ExpandTitle item={item}>{text}</ExpandTitle>
              ),
            };
          }

          if (key === Const.CommonTable.SOURCE) {
            if (type === 'pa') {
              return {
                disableSort: true,
                ...result,
                thStyle: { width: '80px', textAlign: 'center' },
                render: (text, item) => <SourceSpan type="pa" text={text} />,
              };
            }
            return {
              disableSort: true,
              ...result,
              thStyle: { width: '80px', textAlign: 'center' },
              render: text => (
                <SourceSpan text={text} storeName={this.getStoreName(type)} />
              ),
            };
          }

          if (key === Const.CommonTable.TRUSTABILITY) {
            return {
              disableSort: true,
              disableResize: true,
              ...result,
              thStyle: { width: '80px', textAlign: 'center' },
              render: text => <SourceSpan type="r" text={text} />,
            };
          }

          if (key === Const.CommonTable.TYPE) {
            return {
              disableSort: true,
              disableResize: true,
              ...result,
              thStyle: { width: '120px', textAlign: 'center' },
              render: (text, item) => (
                <SourceSpan
                  code={item.newsCategoryCode}
                  storeName={this.getStoreName(type)}
                  text={item.categoryName}
                />
              ),
            };
          }

          if (key === Const.CommonTable.CONTRIBUTOR) {
            return {
              disableSort: true,
              disableResize: true,
              ...result,
              thStyle: { width: '80px', textAlign: 'center' },
              render: text => <SourceSpan text={text} />,
            };
          }

          return result;
        })}
      />
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => {
  return {
    i18n: state.i18n,
    currentTab: state[REDUCER_NAME].currentTab,
    currentChildTab: state[REDUCER_NAME].currentChildTab,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

const mapDispatchToProps = {
  setAPIParams,
};

Table.defaultProps = {
  dateKey: 'publicDate',
  isOnlyShowDate: false,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(mapStateToProps, mapDispatchToProps),
)(NATable);
